var HeaderModule = (function () {
    function HeaderModule() {
    }
    return HeaderModule;
}());
export { HeaderModule };



// WEBPACK FOOTER //
// /codebuild/output/src3658806670/src/client/web-client/src/app/theme/header/header.module.ts.pre-build-optimizer.js